import type { Acknowledgment } from '../../lib/klassenbuchApi';
import { CheckCircle2, Clock3 } from 'lucide-react';

type Props = {
  acknowledgments: Acknowledgment[];
  compact?: boolean;
};

export default function AcknowledgmentBadge({ acknowledgments, compact }: Props) {
  const total = acknowledgments.length;
  const done = acknowledgments.filter((a) => !!a.acknowledged_at).length;

  if (total === 0) return null;

  const complete = done === total;
  const color = complete
    ? 'bg-emerald-100 text-emerald-800 border-emerald-300'
    : 'bg-amber-100 text-amber-800 border-amber-300';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${color}`}
      title={complete ? 'Alle Empfänger haben bestätigt' : `${done} von ${total} Bestätigungen`}
    >
      {complete ? <CheckCircle2 size={12} /> : <Clock3 size={12} />}
      {compact ? `${done}/${total}` : `Kenntnisnahme ${done}/${total}`}
    </span>
  );
}
